import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {sleep} from 'shared/tools';
import qs from 'qs';
import PublicOffer from 'main/stores/offers/PublicOffer';

class JobOfferContainerState {
  store = new DomainStore();

  jobOffer;
  token;
  errors;
  displayAnimation = false;
  signatureData = '';

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    this.token = qs.parse(location.search.replace('?', ''))['token'];

    await this.store._compose([
      endpoints.OFFER.PUBLIC.with(this.token)
    ]);
    this.jobOffer = new PublicOffer(this.store._getSingle(
      types.OFFER
    ));
  }

  setSignatureData(data) {
    this.signatureData = data;
  }

  get signatureRequired() {
    return this.jobOffer.renderedContent.includes('EMPLOYEE_SIGNATURE');
  }

  async acceptOffer() {
    const {model, errors} = await this.store.patch(
      endpoints.OFFER.PUBLIC.ACCEPT.with(this.token),
      types.OFFER,
      {...this.jobOffer, signatureData: this.signatureData}
    );

    this.errors = errors;

    if (model) {
      // delay offer acceptance artificially for UX
      await sleep(500);
      this.jobOffer = model;
      this.displayAnimation = true;
    }
  }
}

export default JobOfferContainerState;
